var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      { staticClass: "p-20 bg-white" },
      [
        _c(
          "el-form",
          { ref: "form", attrs: { "label-width": "100px" } },
          [
            _c("h4", { staticClass: "mb-10 mt-0" }, [_vm._v("掉单状态")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "是否开启：" } },
                  [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      model: {
                        value: _vm.form.new_steal_switch,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "new_steal_switch", $$v)
                        },
                        expression: "form.new_steal_switch",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-5 fs-s3" }, [
                      _vm._v(
                        "开启表示开启掉单，以下规则才会生效，掉单优先顺序：比例漏单>时间扣减>扣款失败"
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-10 mt-0" }, [
              _vm._v("比例漏单及扣款失败"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单基数：" } },
                  [
                    _c(
                      "el-input",
                      {
                        model: {
                          value: _vm.form.missed_cycle_orders,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "missed_cycle_orders", $$v)
                          },
                          expression: "form.missed_cycle_orders",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("单")])],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-10 mt-0" }, [_vm._v("比例漏单")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "漏单概率：" } },
                  [
                    _c(
                      "el-input",
                      {
                        model: {
                          value: _vm.form.missed_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "missed_rate", $$v)
                          },
                          expression: "form.missed_rate",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "起漏金额：" } },
                  [
                    _c(
                      "el-input",
                      {
                        model: {
                          value: _vm.form.missed_min_money,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "missed_min_money", $$v)
                          },
                          expression: "form.missed_min_money",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("元")])],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "top-start",
                      title: "温馨提示",
                      width: "450",
                      trigger: "hover",
                    },
                  },
                  [
                    _c("div", [
                      _vm._v(
                        "\n             有效订单：订单金额大于0且未被掉单的订单。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n             起漏金额：有效订单的订单金额须大于等于起漏金额才会漏单。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n             漏掉的订单将会隐藏且不给下级代理及商户分成。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n             例：订单基数10单，概率40%，商户有效订单每10单漏4单。\n           "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "mt-10 ml-20 el-icon-question text-blue",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.checkRoles(["partner"])
              ? [
                  _c("h4", { staticClass: "mb-10 mt-0" }, [_vm._v("时间扣减")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "扣减基数：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.short_cycle_orders,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "short_cycle_orders", $$v)
                                },
                                expression: "form.short_cycle_orders",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("单"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "扣减概率：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.short_rate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "short_rate", $$v)
                                },
                                expression: "form.short_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "扣减时间：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.short_minute,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "short_minute", $$v)
                                },
                                expression: "form.short_minute",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("分钟"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "top-start",
                            title: "温馨提示",
                            width: "480",
                            trigger: "hover",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "\n             有效订单：订单金额大于0且未被掉单的订单。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             订单真实使用时长减去扣减时间，订单金额未发生变化，则该订单不扣减时间。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             订单扣减时间后，下级看到的订单完结时间=真实完结时间-扣减时间。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             例：扣减时间10分钟，真实使用时长65分钟，订单计费为2元60分钟，该订单真实扣款4元。扣减10分钟后使用时长55分钟，订单金额2元，下级代理及商户按2元分成，剩余2元则按比例分给您及您的上级。\n           "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "mt-10 ml-20 el-icon-question text-blue",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mb-10 mt-0" }, [_vm._v("扣款失败")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "失败概率：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.show_fail_rate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "show_fail_rate", $$v)
                                },
                                expression: "form.show_fail_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "起漏金额：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.show_fail_min_money,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "show_fail_min_money", $$v)
                                },
                                expression: "form.show_fail_min_money",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "top-start",
                            title: "温馨提示",
                            width: "450",
                            trigger: "hover",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "\n             有效订单：订单金额大于0且未被掉单的订单。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             起漏金额：有效订单的订单金额须大于等于起漏金额才会失败。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             失败订单会展示为扣款失败，不给下级代理及商户分成。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             例：订单基数10单，概率40%，商户有效订单每10单失败4单。\n           "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "mt-10 ml-20 el-icon-question text-blue",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mb-10 mt-0" }, [
                    _vm._v("已完成订单漏单"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "漏单基数：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.missed_nologin_cycle_orders,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "missed_nologin_cycle_orders",
                                    $$v
                                  )
                                },
                                expression: "form.missed_nologin_cycle_orders",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("单"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "漏单概率：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.missed_nologin_rate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "missed_nologin_rate", $$v)
                                },
                                expression: "form.missed_nologin_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "起漏金额：" } },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.missed_nologin_min_money,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "missed_nologin_min_money",
                                    $$v
                                  )
                                },
                                expression: "form.missed_nologin_min_money",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "ml-10",
                          attrs: { label: "未登录时长：" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              model: {
                                value: _vm.form.missed_nologin_hours,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "missed_nologin_hours",
                                    $$v
                                  )
                                },
                                expression: "form.missed_nologin_hours",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("小时"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "top-start",
                            title: "温馨提示",
                            width: "450",
                            trigger: "hover",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "\n             有效订单：订单金额大于0且未被掉单的订单。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             起漏金额：有效订单的订单金额须大于等于起漏金额才会漏单。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             漏掉的订单将会隐藏且扣除下级代理及商户分成。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n             例：基数10单，概率40%，未登录时间6小时，若6小时内商户未登录，该时段内商户有效订单每10单漏4单，每6小时轮回。\n           "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "mt-10 ml-20 el-icon-question text-blue",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.type == 1 && _vm.checkRoles(["partner"])
              ? [
                  _c("h4", { staticClass: "mb-10 mt-0" }, [_vm._v("隐藏订单")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否开启：" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.steal_switch,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "steal_switch", $$v)
                          },
                          expression: "form.steal_switch",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 fs-s3" }, [
                        _vm._v("开启表示以下设置时间段内的订单不显示"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "禁止结束：" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.user_forbidden_finish,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "user_forbidden_finish", $$v)
                          },
                          expression: "form.user_forbidden_finish",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 fs-s3" }, [
                        _vm._v(
                          "开启表示以下设置时间段内的充电宝订单归还不会自动结束"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.form.plan, function (item, index) {
                    return _c(
                      "div",
                      { staticClass: "flex align-start flex-wrap" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "mr-20",
                            attrs: { label: "开始时间：" },
                          },
                          [
                            _c("el-time-select", {
                              attrs: {
                                "picker-options": {
                                  start: "00:00",
                                  step: "00:01",
                                  end: "23:59",
                                },
                                placeholder: "开始时间",
                              },
                              model: {
                                value: item.begin,
                                callback: function ($$v) {
                                  _vm.$set(item, "begin", $$v)
                                },
                                expression: "item.begin",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "mr-20",
                            attrs: { label: "结束时间：" },
                          },
                          [
                            _c("el-time-select", {
                              attrs: {
                                "picker-options": {
                                  start: "00:00",
                                  step: "00:01",
                                  end: "23:59",
                                  minTime: item.begin,
                                },
                                placeholder: "结束时间",
                              },
                              model: {
                                value: item.end,
                                callback: function ($$v) {
                                  _vm.$set(item, "end", $$v)
                                },
                                expression: "item.end",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.plan.length < _vm.config.steal_time_length &&
                        index == 0
                          ? _c("el-button", {
                              attrs: { type: "primary", icon: "el-icon-plus" },
                              on: {
                                click: function ($event) {
                                  return _vm.form.plan.push({
                                    start: "",
                                    end: "",
                                  })
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.plan.length > 1 && index > 0
                          ? _c("el-button", {
                              attrs: { type: "danger", icon: "el-icon-minus" },
                              on: {
                                click: function ($event) {
                                  return _vm.form.plan.splice(index, 1)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.postCard()
                      },
                    },
                  },
                  [_vm._v("立即提交")]
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }